export default function initializeParkingWidget(carparkIds, categories) {
  const pollingFrequency = 60 * 1000;
  let intervalId;

  async function refreshParkingWidgets() {
    if (intervalId) clearInterval(intervalId);

    document.getElementById('parkingstatus-unavailable').classList.replace('at-d-flex', 'at-d-none');
    document.querySelectorAll('.availability-text').forEach((el) => {
      el.classList.add('at-d-none');
    });
    document.querySelectorAll('.at-parking-widget-loading-spinner').forEach((el) => {
      el.classList.remove('at-d-none');
    });

    async function fetchParkingAvailability() {
      const url = `/umbraco/surface/parkingavailabilitysurface/ParkingAvailabilityJsonResult?carparkIds=${encodeURIComponent(carparkIds)}&categories=${encodeURIComponent(categories)}`;
      const response = await fetch(url, {
        signal: AbortSignal.timeout(3000),
      });
      if (!response.ok) throw new Error('Network error');
      return response.json();
    }

    async function refreshUI() {
      try {
        document.getElementById('parking-content').classList.remove('at-d-none');
        document.getElementById('parkingstatus-unavailable').classList.replace('at-d-flex', 'at-d-none');
        const allCardLabels = document.querySelectorAll('.at-parking-card-label');
        allCardLabels.forEach((cardLabel) => {
          if (cardLabel) {
            const carparkName = cardLabel.getAttribute('data-title');
            cardLabel.setAttribute('aria-label', `Loading latest ${carparkName} availability`);
          }
        });

        const rawData = await fetchParkingAvailability();
        const data = Object.keys(rawData).reduce((acc, key) => {
          const normalizedKey = key.toLowerCase().replace(/\s+/g, ' ');
          acc[normalizedKey] = rawData[key];
          return acc;
        }, {});

        const now = new Date();
        document.getElementById('last-updated').textContent = `Last updated: ${now.toLocaleTimeString('en-NZ', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        })
          .replace(/ (?=[ap]m)/i, '')
          .toLowerCase()
        } ${now.toLocaleDateString('en-NZ', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
        }).replace(',', '')}`;

        carparkIds.split(',').forEach((id) => {
          const domId = id.replace(/\s/g, '');
          const dataKey = id.toLowerCase().replace(/\s/g, ' ');
          const el = document.getElementById(`${domId}-availability`);
          if (el) {
            const textEl = el.querySelector('.availability-text');
            const spinnerEl = el.querySelector('.at-parking-widget-loading-spinner');
            textEl.textContent = `${data[dataKey] || 0} spaces available`;
            spinnerEl.classList.add('at-d-none');
            textEl.classList.remove('at-d-none');

            const cardLabel = document.getElementById(`${domId}-card-label`);
            if (cardLabel) {
              const carparkName = cardLabel.getAttribute('data-title');
              cardLabel.ariaLabel = `${carparkName} has ${data[id]} available spaces`;
            }
          }
        });
      } catch (error) {
        document.getElementById('parkingstatus-unavailable').classList.replace('at-d-none', 'at-d-flex');
        document.querySelectorAll('.at-parking-widget-loading-spinner').forEach((el) => {
          el.classList.add('at-d-none');
        });
        document.querySelectorAll('.availability-text').forEach((el) => {
          el.classList.add('at-d-none');
        });
        document.getElementById('parking-content').classList.add('at-d-none');
      }
    }

    await refreshUI();
    intervalId = setInterval(refreshUI, pollingFrequency);
  }

  try {
    refreshParkingWidgets();
  } catch (error) {
    document.getElementById('parkingstatus-unavailable')?.classList.replace('at-d-none', 'at-d-flex');
  }

  return {
    refresh: refreshParkingWidgets,
    cleanup: () => {
      if (intervalId) clearInterval(intervalId);
    },
  };
}
